import React, { useEffect } from 'react'
import { ShareWorkoutCardContainer } from './styles'
import PropTypes from "prop-types";
import { Border } from '../SocialFeedsV2/styles';
import { ImageUrl } from '../../utils/constants';
import LazyImage from '../common/LazyImage/LazyImage';

const ShareWorkoutCard = ({workoutName, workoutData,feed,onClick}) => {

  useEffect(()=>{
    // window.console.log("HI")
  },[])

  return (
    <ShareWorkoutCardContainer onClick={()=>onClick && onClick(feed,feed.id)} style={{cursor:onClick && 'pointer'}}>
      <div className='title'>Crushed my workout! 🎉</div>
      <div className='sub-title'>
        {workoutData?.background_image && (
          <div className="activity-icon">
            <LazyImage style={{ width: "28px", height: "28px", objectFit: "contain" }} src={`${ImageUrl}/${workoutData.background_image}`} />
          </div>
        )}
        <div>{workoutName || workoutData?.name} | Workout Completed</div>
      </div>
      <Border style={{marginBottom:"0px", background:"#EFEFEF"}}/>
      <div className='workout-container'>
        <div className='workout-card'>
          <div className='name'>Active Time</div>
          <div className='activity-log'>{workoutData?.time}</div>
        </div>

        <div className='workout-card'>
          <div className='name'>Workout Intensity</div>
          <div className='activity-log'>{workoutData?.intensity}</div>
        </div>

        <div className='workout-card'>
          <div className='name'>Points Earned</div>
          <div className='activity-log'>{workoutData?.points}</div>
        </div>

      </div>

    </ShareWorkoutCardContainer>
  )
}

ShareWorkoutCard.propTypes = {
  workoutName: PropTypes.string,
  workoutData:PropTypes.string,
  feed:PropTypes.object,
  onClick:PropTypes.func
}

export default ShareWorkoutCard